import React, { useEffect, useState } from 'react';
import useParam from '../../context/ParamContext';
import { Typography } from '@mui/material';

const transformFunctions = {
  reportStatus: (taskValue, index) => {
    const lastReport = taskValue[taskValue.length - 1];
    if (lastReport) {
      if (lastReport.interruptionReason?.name) {
        return <Typography key={index}>Megszakítás oka: {lastReport.interruptionReason.name}</Typography>;
      }
      if (lastReport.downtimeReason?.name) {
        return <Typography key={index}>Állásidő oka: {lastReport.downtimeReason.name}</Typography>;
      }
    }
    return null;
  },
};

const TooltipContent = ({ eventInfo }) => {
  const { params } = useParam();
  const [tooltipObj, setTooltipObj] = useState(null);

  useEffect(() => {
    const type = eventInfo.event._def.extendedProps.eventData.type;
    let paramKey = 'TASKGANTT_HINT_CONTENT';
    if (type === 'PRODUCTION') {
      paramKey = 'TASKGANTT_PRODUCTION_HINT_CONTENT';
    }

    if (params[paramKey]) {
      const parsedObj = JSON.parse(params[paramKey]);
      setTooltipObj(parsedObj);
    }
  }, [params]);

  const task = eventInfo.event._def.extendedProps.eventData;

  const getFieldValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => {
      if (!acc) return null;
      if (Array.isArray(acc)) {
        return acc[0]?.[part];
      }
      return acc[part];
    }, obj);
  };

  const setTooltipContent = () => {
    if (!tooltipObj || !task) {
      return null;
    }

    return tooltipObj.map((item, index) => {
      const { label, fieldName, displayType } = item;
      const taskValue = getFieldValue(task, fieldName);
      if (Array.isArray(taskValue)) {
        if (displayType && transformFunctions[displayType]) {
          return transformFunctions[displayType](taskValue, index);
        }

        return taskValue.map((value, subIndex) => (
          <Typography key={`${index}-${subIndex}`}>
            {label}: {value}
          </Typography>
        ));
      } else {
        return (
          <Typography key={index}>
            {label}: {taskValue}
          </Typography>
        );
      }
    });
  };

  const tooltipContent = setTooltipContent();

  return <div>{tooltipContent}</div>;
};

export default TooltipContent;
